import React from 'react';
import PropTypes from 'prop-types';
import { Alert as AntAlert } from 'antd';
import { useTheme } from '../../../contexts/ThemeContext';

const Alert = ({ 
  message, 
  description, 
  type = 'info', 
  showIcon = true, 
  closable = false,
  style,
  onClose,
  ...props 
}) => {
  const { theme } = useTheme();

  const getAlertStyle = (alertType) => {
    const baseStyle = {
      borderRadius: '8px',
      border: '1px solid',
      transition: 'all 0.3s ease',
    };

    const typeStyles = {
      success: {
        backgroundColor: '#f6ffed',
        color: '#52c41a',
        borderColor: '#b7eb8f',
      },
      info: {
        backgroundColor: '#e6f7ff',
        color: '#1890ff',
        borderColor: '#91d5ff',
      },
      warning: {
        backgroundColor: '#fffbe6',
        color: '#faad14',
        borderColor: '#ffe58f',
      },
      error: {
        backgroundColor: '#fff2f0',
        color: '#ff4d4f',
        borderColor: '#ffccc7',
      },
    };

    return {
      ...baseStyle,
      ...typeStyles[alertType],
    };
  };

  const alertStyle = {
    ...getAlertStyle(type),
    ...style,
  };

  return (
    <AntAlert
      message={message}
      description={description}
      type={type}
      showIcon={showIcon}
      closable={closable}
      onClose={onClose}
      style={alertStyle}
      {...props}
    />
  );
};

Alert.propTypes = {
  message: PropTypes.node.isRequired,
  description: PropTypes.node,
  type: PropTypes.oneOf(['success', 'info', 'warning', 'error']),
  showIcon: PropTypes.bool,
  closable: PropTypes.bool,
  style: PropTypes.object,
  onClose: PropTypes.func,
};

export default Alert; 